<script>
import Multiselect from "vue-multiselect";

export default {
  components: {
    Multiselect,
  },
  // {
  //   Este filtro tiene un tratamiento especial,
  // mirar la tabla router/views/reports/management, para ver la función para tratar este filtro
  // }
  props: {
    value: {
      required: false,
      default: () => [],
    },
    multiple: {
      type: Boolean,
      required: false,
      default: false,
    },
    opts: {
      type: Array,
      required: false,
      default: () => [],
    },
    withOutBorder: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      required: false,
      default: "",
    },
    fetchOptions: {
      type: Function,
      required: false,
    },
    reqParams: {
      type: Object,
      required: false,
    },
    withOutBorder: {
      type: Boolean,
      default: false,
    },
    vid: {
      type: String,
    },
    rules: {
      type: [Object, String],
      default: "",
    },
  },
  data() {
    return {
      loading: false,
      options: [],
      loadingOptions: false,
      optionsMounted: true,
      optionsCache: [],
      selectedCountries: [],
    };
  },
  computed: {
    // ...authComputed,
    inputVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  mounted: function () {
    this.populateOptions("");
  },
  methods: {
    populateOptions(query) {
      let context = this;
      console.log(this.value);
      console.log(this.inputVal);
      context.loadingOptions = true;
      let promise;
      if (query) {
        promise = context.fetchOptions(`?filter_cod=${query}`);
      } else {
        promise = context.fetchOptions(`?filter_cod=`);
      }
      return promise
        .then((data) => {
          console.log(data);
          let listOptions = [];
          console.log(data);
          data.results.forEach((opt) => {
            listOptions.push({
              id: opt.id,
            });
          });
          context.options = listOptions;
          context.loadingOptions = false;
          context.optionsMounted = true;
        })
        .catch((error) => {
          context.$axios_error_noty(error, context);
          context.loadingOptions = false;
          context.optionsMounted = true;
        });
    },

    asyncFindOptions: _.debounce(function (searchQuery) {
      this.populateOptions(searchQuery);
    }, 600),

    asyncFind: _.debounce(function (query) {
      this.populateOptions(query);
    }, 1000),

    labelOfOption(opt) {
      let context = this;
      let optionFound = context.options.find((x) => x.id === opt);
      if (!optionFound) {
        let cacheFound = context.optionsCache.find((x) => x.id === opt);
        return cacheFound
          ? cacheFound.name
          : context.optionsMounted
          ? `${"label_not_found"}: ${opt}`
          : "";
      } else {
        if (context.inputVal === opt) {
          if (!context.optionsCache.find((x) => x.id === opt)) {
            context.optionsCache.push(optionFound);
          }
        }
        return optionFound.name;
      }
    },
    toggleReadonly(event) {
      if (event.target.getAttribute("readonly") == "readonly") {
        event.target.removeAttribute("readonly");
      }
      event.target.focus();
      this.$refs.cashier.focus();
    },
  },
};
</script>

<template>
  <ValidationProvider :vid="vid" :name="$attrs.name" :rules="rules">
    <b-form-group :label="label" class="mb-1" slot-scope="{ errors }" v-bind="$attrs">
      <div
        v-on:click="toggleReadonly"
        class="rounded d-flex"
        :class="[
          errors[0] && !withOutBorder
            ? 'border border-danger'
            : inputVal && !withOutBorder
            ? 'border border-success'
            : null,
        ]"
      >
        <slot name="prepend"> </slot>
        <multiselect
          class="especial_multiselect_search"
          v-model="inputVal"
          :options="options"
          :loading="loadingOptions"
          :multiple="true"
          :close-on-select="true"
          :clear-on-select="false"
          select-label="Seleccionar"
          selected-label="Seleccioando"
          deselect-label="Remover"
          placeholder="Cajeros"
          label="id"
          track-by="id"
          :internal-search="false"
          @search-change="asyncFind"
          :hide-selected="false"
          ref="cashier"
          :taggable="true"
        >
          <template slot="selection" slot-scope="{ values, search, isOpen }"
            ><span class="multiselect__single" v-if="values.length" v-show="!isOpen"
              >{{ values.length }} cajeros seleccionados</span
            ></template
          >
          <!-- <template slot="noOptions">
            <span> Digita el Código de cajero </span>
          </template> -->
        </multiselect>
      </div>
      <span class="text-danger">{{ errors[0] }}</span>
      <!-- <span class="typo__label form__label" v-show="errors">{{ errors[0] }}</span> -->
    </b-form-group>
  </ValidationProvider>
</template>
<style lang="scss">
// .multiselect__tags {
// 	min-height: 38px;
// 	display: block;
// 	max-height: 30px;
// 	padding: 6px 40px 0 8px;
// 	border-radius: 5px;
// 	border: 1px solid #0570a7;
// 	background: #fff;
// 	font-size: 14px
// }
.especial_multiselect_search {
  height: auto;
}
</style>
